import { useState, forwardRef, useEffect } from "react";
import { Icon } from "@iconify/react";
import editFill from "@iconify/icons-eva/edit-fill";
import deleteFill from "@iconify/icons-eva/trash-2-fill";
import addFill from "@iconify/icons-eva/plus-fill";
import { useNavigate } from "react-router-dom";
import { Portal } from "@mui/base";
import {
  Card,
  Table,
  Stack,
  Button,
  TextField,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  IconButton,
  Tooltip,
} from "@mui/material";
import Page from "../components/Page";
import Scrollbar from "../components/Scrollbar";
import { LocationListHead } from "../components/_dashboard/location";
import { filter } from "lodash";
import { sort } from "fast-sort";
import Slide from "@mui/material/Slide";
import LinearProgress from "@mui/material/LinearProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { CallApi } from "../statics.js";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian_calendar from "react-date-object/calendars/persian";
import persian_language from "react-date-object/locales/persian_fa";
import persian_language_en from "react-date-object/locales/persian_en";
import moment from "moment-jalaali";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/colors/green.css";

const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

// ----------------------------------------------------------------------
function applySortFilter(array, order, orderBy, query) {
  let list = array;
  let result = [];
  if (order === "asc") {
    result = sort(list).by([
      {
        asc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { asc: (u) => u.createdAt },
    ]);
  } else {
    result = sort(list).by([
      {
        desc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { desc: (u) => u.createdAt },
    ]);
  }

  if (query) {
    return filter(
      result,
      (_item) => _item.code.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return result;
}

const TABLE_HEAD = [
  { id: "code", label: "Discount Code", alignRight: false },
  { id: "discount_percentage", label: "Discount %", alignRight: false },
  { id: "start_date", label: "Start Date", alignRight: false },
  { id: "end_date", label: "End Date", alignRight: false },
  { id: "status", label: "Status", alignRight: false },
  { id: "actions", label: "Actions", alignRight: false },
];

function CustomInput({ onFocus, value, onChange, placeholder, label }) {
  return (
    <TextField
      sx={{ width: "200px" }}
      size="small"
      label={label}
      onFocus={onFocus}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      InputProps={{
        className: "custom-input",
      }}
    />
  );
}

export default function DiscountCodes() {
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackType, setSnackType] = useState("success");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [dataLoading, setDataLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  // Dialog states
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [currentDeleteItem, setCurrentDeleteItem] = useState(null);
  const [formData, setFormData] = useState({
    code: "",
    discount_percentage: "",
    start_date: null,
    end_date: null,
  });

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    readAllDiscountCodes();
  }, []);

  useEffect(() => {
    readAllDiscountCodes();
  }, [page]);

  const readAllDiscountCodes = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: page,
      count: rowsPerPage,
    };
    setDataLoading(true);
    CallApi("getDiscountCodes", "post", data).then((result) => {
      try {
        setDataLoading(false);
        if (result.status === 200) {
          setTableData(result.discountCodes || []);
          setTotalItems(result.paginateInfo?.totalItems || 0);
        }
      } catch (error) {
        console.log("error: ", error);
        setDataLoading(false);
      }
    });
  };

  const handleChangePage = (e, value) => {
    setPage(value);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const filteredDataList = applySortFilter(tableData, order, orderBy, "");

  const isDataNotFound = filteredDataList.length === 0;

  const handleOpenDialog = (item = null) => {
    setEditingItem(item);
    if (item) {
      // Extract date part from API dates (remove time part)
      const startDateStr = item.start_date.split("T")[0];
      const endDateStr = item.end_date.split("T")[0];

      // Convert Persian dates to Gregorian dates using moment-jalaali
      const startDateGregorian = moment(startDateStr, "jYYYY-jMM-jDD").format(
        "YYYY-MM-DD"
      );
      const endDateGregorian = moment(endDateStr, "jYYYY-jMM-jDD").format(
        "YYYY-MM-DD"
      );

      setFormData({
        code: item.code,
        discount_percentage: item.discount_percentage,
        start_date: new DateObject(startDateGregorian),
        end_date: new DateObject(endDateGregorian),
      });
    } else {
      setFormData({
        code: "",
        discount_percentage: "",
        start_date: null,
        end_date: null,
      });
    }
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setEditingItem(null);
    setFormData({
      code: "",
      discount_percentage: "",
      start_date: null,
      end_date: null,
    });
  };

  const handleSubmit = () => {
    if (
      !formData.code ||
      !formData.discount_percentage ||
      !formData.start_date ||
      !formData.end_date
    ) {
      setSnackbarMessage("Please fill in all fields");
      setSnackType("error");
      setSnackbarOpen(true);
      return;
    }

    // Validate date range
    const startDate = new DateObject(formData.start_date);
    const endDate = new DateObject(formData.end_date);

    if (endDate.toDate() < startDate.toDate()) {
      setSnackbarMessage("End date must be after start date");
      setSnackType("error");
      setSnackbarOpen(true);
      return;
    }
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      code: formData.code,
      discount_percentage: parseFloat(formData.discount_percentage),
      start_date:
        new DateObject(formData.start_date)
          .convert(persian_calendar, persian_language_en)
          .format("YYYY-MM-DD") + " 00:00:00",
      end_date:
        new DateObject(formData.end_date)
          .convert(persian_calendar, persian_language_en)
          .format("YYYY-MM-DD") + " 23:59:59",
    };

    if (editingItem) {
      data.id = editingItem.id;
      CallApi("updateDiscountCode", "post", data).then((result) => {
        if (result.status === 200) {
          setSnackbarMessage("Discount code updated successfully");
          setSnackType("success");
          setSnackbarOpen(true);
          handleCloseDialog();
          readAllDiscountCodes();
        }
      });
    } else {
      CallApi("createDiscountCode", "post", data).then((result) => {
        if (result.status === 200) {
          setSnackbarMessage("Discount code created successfully");
          setSnackType("success");
          setSnackbarOpen(true);
          handleCloseDialog();
          readAllDiscountCodes();
        }
      });
    }
  };

  const handleDelete = (item) => {
    setCurrentDeleteItem(item);
    setDeleteDialogOpen(true);
  };

  const confirmDelete = () => {
    setDeleteDialogOpen(false);
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      id: currentDeleteItem.id,
    };
    CallApi("deleteDiscountCode", "post", data).then((result) => {
      if (result.status === 200) {
        setSnackbarMessage("Discount code deleted successfully");
        setSnackType("success");
        setSnackbarOpen(true);
        readAllDiscountCodes();
      }
    });
  };

  const getStatusChip = (item) => {
    // Get current date
    const now = moment();

    // Extract date part from API dates (remove time part)
    const startDateStr = item.start_date.split("T")[0];
    const endDateStr = item.end_date.split("T")[0];

    // Convert Persian dates to Gregorian dates using moment-jalaali
    const startDate = moment(startDateStr, "jYYYY-jMM-jDD");
    const endDate = moment(endDateStr, "jYYYY-jMM-jDD");

    // Check if dates are valid
    if (!startDate.isValid() || !endDate.isValid()) {
      return <Chip label="Invalid Date" color="default" size="small" />;
    }

    if (now.isBefore(startDate)) {
      return <Chip label="Not Started" color="warning" size="small" />;
    } else if (now.isAfter(endDate)) {
      return <Chip label="Expired" color="error" size="small" />;
    } else {
      return <Chip label="Active" color="success" size="small" />;
    }
  };

  return (
    <Page title="Discount Codes | Admin Panel">
      {dataLoading && (
        <LinearProgress
          color="primary"
          sx={{
            ml: -2,
            zIndex: "100000",
            width: "100%",
            position: "fixed",
            top: "0px",
          }}
        />
      )}
      {!dataLoading && (
        <Container sx={{ position: "relative" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Discount Codes
            </Typography>
            <Button
              variant="contained"
              startIcon={<Icon icon={addFill} />}
              onClick={() => handleOpenDialog()}
            >
              Add Discount Code
            </Button>
          </Stack>

          <Card>
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <LocationListHead
                    headLabel={TABLE_HEAD}
                    rowCount={filteredDataList.length}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  {!isDataNotFound && (
                    <TableBody>
                      {filteredDataList.map((row) => {
                        return (
                          <TableRow hover key={row.id} tabIndex={-1}>
                            <TableCell>
                              <Typography variant="subtitle2" noWrap>
                                {row.code}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">
                                {row.discount_percentage}%
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">
                                {row.start_date
                                  .split("T")[0]
                                  .replace(/-/g, "/")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">
                                {row.end_date.split("T")[0].replace(/-/g, "/")}
                              </Typography>
                            </TableCell>
                            <TableCell>{getStatusChip(row)}</TableCell>
                            <TableCell>
                              <Stack direction="row" spacing={1}>
                                <Tooltip title="Edit">
                                  <IconButton
                                    size="small"
                                    onClick={() => handleOpenDialog(row)}
                                  >
                                    <Icon icon={editFill} />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete">
                                  <IconButton
                                    size="small"
                                    color="error"
                                    onClick={() => handleDelete(row)}
                                  >
                                    <Icon icon={deleteFill} />
                                  </IconButton>
                                </Tooltip>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                  {isDataNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={6}
                          sx={{
                            py: 3,
                            color: "text.disabled",
                            fontSize: "12px",
                          }}
                        >
                          No Data Found
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>
            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={totalItems}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
            />
          </Card>
        </Container>
      )}

      {/* Dialog for Add/Edit */}
      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        // maxWidth="sm"
        // fullWidth
        sx={{ p: 2, mt: 2 }}
        TransitionComponent={Transition}
      >
        <DialogTitle>
          {editingItem ? "Edit Discount Code" : "Add New Discount Code"}
        </DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <Stack spacing={3} sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label="Discount Code"
              value={formData.code}
              onChange={(e) =>
                setFormData({ ...formData, code: e.target.value })
              }
              placeholder="e.g. SUMMER2024"
            />
            <TextField
              fullWidth
              label="Discount Percentage"
              type="number"
              value={formData.discount_percentage}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  discount_percentage: e.target.value,
                })
              }
              placeholder="e.g. 20"
              inputProps={{ min: 0, max: 100 }}
            />
            <DatePicker
              render={
                <CustomInput placeholder="Start Date" label="Start Date" />
              }
              calendar={persian_calendar}
              locale={persian_language}
              minDate={new DateObject()}
              weekDays={weekDays}
              shadow={false}
              value={formData.start_date}
              onChange={(e) => setFormData({ ...formData, start_date: e })}
              className="rmdp-mobile"
            />
            <DatePicker
              render={<CustomInput placeholder="End Date" label="End Date" />}
              calendar={persian_calendar}
              locale={persian_language}
              minDate={
                formData.start_date
                  ? new DateObject(formData.start_date)
                  : new DateObject()
              }
              weekDays={weekDays}
              shadow={false}
              value={formData.end_date}
              onChange={(e) => setFormData({ ...formData, end_date: e })}
              className="rmdp-mobile"
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained">
            {editingItem ? "Update" : "Create"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={deleteDialogOpen}
        TransitionComponent={Transition}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Deleting Discount Code</DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <DialogContentText id="alert-dialog-description">
            {"Are you sure for deleting '" +
              (currentDeleteItem?.code || "") +
              "'?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={confirmDelete}>Yes</Button>
          <Button onClick={() => setDeleteDialogOpen(false)} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Portal>
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          TransitionComponent={SlideTransition}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackType}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
    </Page>
  );
}
